<template>
  <div v-if="examinationPart&&currentPageComponent">
    <div v-if="isDebug" class="debug_str">ページのコンポーネント（{{ currentPageComponent }}）</div>
    <keep-alive>
      <component class="examination_page" :is="currentPageComponent" ref="refPageComponent" :isDebug="isDebug"
                  :examinationPart="examinationPart" :canEdit="canEdit" :showDescription="showDescription"
                  v-model="currentPageParams"
      />
    </keep-alive>

  </div>
</template>

<script>
import commonMixin from '../../common_exam_part';
import wt1_p1_t2_p01 from './検査２/p01';
import wt1_p1_t2_p02 from './検査２/p02';
import wt1_p1_t2_p03 from './検査２/p03';
import wt1_p1_t2_p04 from './検査２/p04';
import wt1_p1_t2_p05 from './検査２/p05';
import wt1_p1_t2_p06 from './検査２/p06';
import wt1_p1_t2_p07 from './検査２/p07';
import wt1_p1_t2_p08 from './検査２/p08';
import wt1_p1_t2_p09 from './検査２/p09';
import wt1_p1_t2_p10 from './検査２/p10';
import wt1_p1_t2_p11 from './検査２/p11';
import wt1_p1_t2_p12 from './検査２/p12';
import wt1_p1_t2_p13 from './検査２/p13';
import wt1_p1_t2_p14 from './検査２/p14';
const LogHeader = 'WT-1/練習１/検査２';

export default {
  mixins: [
    commonMixin,
  ],
  components: {
    wt1_p1_t2_p01,
    wt1_p1_t2_p02,
    wt1_p1_t2_p03,
    wt1_p1_t2_p04,
    wt1_p1_t2_p05,
    wt1_p1_t2_p06,
    wt1_p1_t2_p07,
    wt1_p1_t2_p08,
    wt1_p1_t2_p09,
    wt1_p1_t2_p10,
    wt1_p1_t2_p11,
    wt1_p1_t2_p12,
    wt1_p1_t2_p13,
    wt1_p1_t2_p14,
  },
  props: {
    isDebug: { default: false },
  },
  created() {
    console.log(`[${LogHeader}] created() CALLED`);
  },
  mounted() {
    console.log(`[${LogHeader}] mounted() CALLED`);
  },
  activated() {
    console.log(`[${LogHeader}] activated() CALLED`);
  },
  deactivated() {
    console.log(`[${LogHeader}] deactivated() CALLED`);
  },
  computed: {
    currentPageParams: {
      get() {
        return this.allPageParamsSet[this.currentPageName];
      },
      set(newValue) {//子コンポーネントで変更が発生したが為に呼ばれるので変更チェックは不要
        //console.log(`[${LogHeader}] pageParams(${this.currentPageName}) changed -> emitting(input)`, newValue);//デバッグ用（本番コメントアウト）
        this.$emit('input', {
          p01: this.currentPageName=='p01'? newValue: this.params.p01,
          p02: this.currentPageName=='p02'? newValue: this.params.p02,
          p03: this.currentPageName=='p03'? newValue: this.params.p03,
          p04: this.currentPageName=='p04'? newValue: this.params.p04,
          p05: this.currentPageName=='p05'? newValue: this.params.p05,
          p06: this.currentPageName=='p06'? newValue: this.params.p06,
          p07: this.currentPageName=='p07'? newValue: this.params.p07,
          p08: this.currentPageName=='p08'? newValue: this.params.p08,
          p09: this.currentPageName=='p09'? newValue: this.params.p09,
          p10: this.currentPageName=='p10'? newValue: this.params.p10,
          p11: this.currentPageName=='p11'? newValue: this.params.p11,
          p12: this.currentPageName=='p12'? newValue: this.params.p12,
          p13: this.currentPageName=='p13'? newValue: this.params.p13,
          p14: this.currentPageName=='p14'? newValue: this.params.p14,
          p15: this.currentPageName=='p15'? newValue: this.params.p15,
          p16: this.currentPageName=='p16'? newValue: this.params.p16,
          p17: this.currentPageName=='p17'? newValue: this.params.p17,
          p18: this.currentPageName=='p18'? newValue: this.params.p18,
          p19: this.currentPageName=='p19'? newValue: this.params.p19,
          p20: this.currentPageName=='p20'? newValue: this.params.p20,
          p21: this.currentPageName=='p21'? newValue: this.params.p21,
          p22: this.currentPageName=='p22'? newValue: this.params.p22,
        });
      }
    },
  },
  methods: {
    canMovePage() {
      console.log(`[${LogHeader}] canMovePage() CALLED`);
      if (typeof this.$refs.refPageComponent.canMovePage === 'function') {
        return this.$refs.refPageComponent.canMovePage();
      }
      return true;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
